/* Zumm Health — Global Animation Engine — Option B Warm Vitality */
(function() {
  'use strict';

  /* ---- Cursor Glow ---- */
  const glow = document.createElement('div');
  glow.id = 'zh-cursor-glow';
  Object.assign(glow.style, {
    position: 'fixed', width: '300px', height: '300px',
    background: 'radial-gradient(circle, rgba(108,63,219,0.12) 0%, transparent 70%)',
    borderRadius: '50%', pointerEvents: 'none', zIndex: '9999',
    transform: 'translate(-50%, -50%)', transition: 'left 0.15s ease, top 0.15s ease',
    top: '-999px', left: '-999px'
  });
  document.body.appendChild(glow);
  document.addEventListener('mousemove', function(e) {
    glow.style.left = e.clientX + 'px';
    glow.style.top = e.clientY + 'px';
  });

  /* ---- Stats Ticker ---- */
  const stats = [
    '✦ 10 Billion CFU per Dose',
    '✦ 15+ Probiotic Strains',
    '✦ Doctor Formulated',
    '✦ Third-Party Tested',
    '✦ 98% Parent Satisfaction',
    '✦ All-Natural Ingredients',
    '✦ Kid-Safe Formula',
    '✦ Non-GMO Verified'
  ];

  const ticker = document.createElement('div');
  ticker.id = 'zh-stats-ticker';
  Object.assign(ticker.style, {
    width: '100%', overflow: 'hidden',
    background: 'linear-gradient(90deg, #6C3FDB, #FF6B6B)',
    padding: '12px 0', position: 'relative', zIndex: '10'
  });

  const track = document.createElement('div');
  track.className = 'zh-ticker-track';
  Object.assign(track.style, {
    display: 'flex', whiteSpace: 'nowrap', gap: '0',
    animation: 'zhTicker 30s linear infinite',
    background: 'transparent'
  });

  const content = stats.concat(stats).join('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
  track.innerHTML = '<span class="zh-ticker-item" style="color:#fff;font-size:0.8rem;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;">' + content + '</span>';
  ticker.appendChild(track);

  const style = document.createElement('style');
  style.textContent = '@keyframes zhTicker { 0%{transform:translateX(0)} 100%{transform:translateX(-50%)} }';
  document.head.appendChild(style);

  const heroSection = document.getElementById('zh-hero-medical');
  if (heroSection && heroSection.nextSibling) {
    heroSection.parentNode.insertBefore(ticker, heroSection.nextSibling);
  } else {
    const main = document.querySelector('main') || document.body;
    main.insertBefore(ticker, main.firstChild);
  }

  /* ---- Global Scroll Reveal ---- */
  const revealObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('zh-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  document.querySelectorAll('.zh-reveal:not([style*="opacity"])').forEach(function(el) {
    revealObserver.observe(el);
  });

})();